module.exports = __webpack_public_path__ + "static/couple-watching-sunset.96213ae6.webp";